import { render, staticRenderFns } from "./otherfile.vue?vue&type=template&id=36b88dfb&scoped=true&"
import script from "./otherfile.vue?vue&type=script&lang=js&"
export * from "./otherfile.vue?vue&type=script&lang=js&"
import style0 from "./otherfile.vue?vue&type=style&index=0&id=36b88dfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b88dfb",
  null
  
)

export default component.exports